import { BackOfficeAPI } from 'api/build/backofficeAPI';

export * from 'api/build/backofficeAPI';
export default new BackOfficeAPI();
